export var BSC_TOKENS = {
    BNB: "BNB",
    USDT: "0x55d398326f99059fF775485246999027B3197955",
    USDC: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    CAKE: "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
    TRUST: "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
    QUANTA: "0xdD6913cb8EAbee7cF3d26B1D396E2e5c30cf5482",
};
export var erc20Abi = [
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [{ name: "owner", type: "address" }],
        outputs: [{ name: "balance", type: "uint256" }],
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [{ name: "", type: "uint8" }],
    },
];
export var formatBalance = function (value) {
    if (!Number.isFinite(value) || value === 0)
        return "0";
    var sign = value < 0 ? "-" : "";
    var abs = Math.abs(value);
    var units = [
        { v: 1e12, s: "T" },
        { v: 1e9, s: "B" },
        { v: 1e6, s: "M" },
        { v: 1e3, s: "K" },
    ];
    for (var _i = 0, units_1 = units; _i < units_1.length; _i++) {
        var u = units_1[_i];
        if (abs >= u.v) {
            var compact = Math.floor((abs / u.v) * 100) / 100;
            return "".concat(sign).concat(compact).concat(u.s);
        }
    }
    var decimals = 0;
    if (abs < 1)
        decimals = 4;
    else if (abs < 10)
        decimals = 2;
    else if (abs < 100)
        decimals = 1;
    else
        decimals = 0;
    var factor = Math.pow(10, decimals);
    var floored = Math.floor(abs * factor + 1e-10) / factor;
    if (floored === 0)
        return "0";
    if (decimals === 0)
        return sign + String(floored);
    return (sign +
        floored
            .toFixed(decimals)
            .replace(/\.?0+$/, ""));
};
